import {isNotNil} from 'ramda';

export const parseIntIfNotNil = (value: string | null | undefined) =>
  isNotNil(value) ? parseInt(value) : undefined;
